export const pvcShutter = {
  overview: {
    titles: [
      "Economical",
      "Maintenance Free Beautiful Finish",
      "Moisture Resistant",
      "Reinforced to Make Them Strong"
    ],
    contents: [
      "If you are on a budget, you can still enjoy the flexibility and beauty of shutters. PVC shutters are the least expensive of the shutter options, but they still provide the same benefits and they look amazing. At SOHO, we can give you a free quote during our first visit.",
      "PVC interior shutters will not crack, peel, fade, or deteriorate like wood. Our perfectly finished PVC shutters are scratch and dent resistant. They never need sanding, staining, or painting.",
      "The Polysatin compound of our PVC shutters is specifically designed to stand up to damp or humid conditions.",
      "Our PVC shutters are specially designed to make them exceptionally strong. They are reinforced in major stress points with interior aluminum bracing and resin blocks for extra strength and stability."
    ]
  },
  description: {
    titles: ["", ""],
    contents: ["", ""]
  }
};
